export const generateSelectRangeOptions = (from: number, to: number) =>
  Array(to - from + 1)
    .fill({})
    .map((_, idx) => {
      return {
        value: `${from + idx}`,
        label: `${from + idx}`,
      };
    });
